import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { FormInput } from 'components/input/hook-form';
import { useForm, Controller } from 'react-hook-form';
import dayjs from 'dayjs';
import * as yup from 'yup';
import { format } from 'date-fns';
import { useCreateWorkCalendarApiMutation } from 'lib/api/admin/adminWorkCalendar';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { useState } from 'react';

interface IAddWorkEventDialogProps {
    open: boolean;
    handleClose: () => void;
    initialDate?: Date | null;
}

interface AddWorkEventFormValues {
    title: string;
    date: dayjs.Dayjs;
}

const AddWorkEventDialog = ({ open, handleClose, initialDate }: IAddWorkEventDialogProps) => {
    const [loading, setLoading] = useState(false);
    const [createWorkCalendar] = useCreateWorkCalendarApiMutation();
    const { handleSubmit, control, setValue } = useForm<AddWorkEventFormValues>({
        mode: 'onSubmit',
        defaultValues: {
            date: initialDate ? dayjs(initialDate) : dayjs()
        },
        resolver: yupResolver(
            yup
                .object({
                    title: yup.string().required('*Title is required'),
                    date: yup.date().required('*Date is required')
                })
                .required()
        )
    });

    const onSubmit = (data: AddWorkEventFormValues) => {
        createWorkCalendar({
            title: data.title,
            date: format(new Date(data.date.toISOString()), 'yyyy-MM-dd')
        })
            .unwrap()
            .then(() => {
                setLoading(false);
                withReactContent(Swal).fire('Sukses', 'Berhasil menambahkan data!', 'success');
            })
            .catch((error) => {
                console.error('Error creating work event:', error);
            })
            .finally(() => {
                setLoading(false);
                handleClose();
            });
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div>
                        <DialogTitle variant="h3">Create Holiday</DialogTitle>
                        <DialogContent>
                            <Grid container spacing={20} direction={'column'}>
                                <Grid item>
                                    <FormInput control={control} label="Title" type="text" name="title" />
                                </Grid>
                                <Grid item>
                                    <Controller
                                        name="date"
                                        control={control}
                                        render={({ field }) => (
                                            <>
                                                <Typography variant="caption" sx={{ paddingTop: '0', marginTop: '0' }}>
                                                    Holiday Date
                                                </Typography>
                                                <MobileDatePicker
                                                    disabled
                                                    value={field.value}
                                                    slotProps={{ textField: { fullWidth: true } }}
                                                    onChange={(date: dayjs.Dayjs | null) => {
                                                        if (date) {
                                                            setValue('date', date, { shouldValidate: true });
                                                        }
                                                    }}
                                                />
                                            </>
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button size="large" type="submit">
                                Create
                            </Button>
                        </DialogActions>
                    </div>
                </form>
            </LocalizationProvider>
        </Dialog>
    );
};

export default AddWorkEventDialog;
